(function () {
  'use strict';

  const header = document.getElementById('header-component');
  if (!header) return;

  // Section keys that need black header on the homepage
  const FORCE_BLACK_KEYS = [
    'hero_hXey3T',              // avant-dernier panel
    'featured_product_Ti8LR3',  // dernier panel: home-footer-panel
  ];

  function getSectionKeyFromEl(el) {
    let node = el;
    while (node && node !== document.documentElement) {
      if (node.id && node.id.startsWith('shopify-section')) {
        const parts = node.id.split('__');
        return parts[parts.length - 1];
      }
      node = node.parentElement;
    }
    return null;
  }

  function checkForceBlack(el) {
    if (el.closest && el.closest('[data-header-black="true"]')) return true;
    if (el.querySelector && el.querySelector('[data-header-black="true"]')) return true;
    const key = getSectionKeyFromEl(el);
    if (key && FORCE_BLACK_KEYS.includes(key)) return true;
    return false;
  }

  // ── Homepage: listen to panel engine events ──
  function updateHomepageFromPanel(panel) {
    const force = panel ? checkForceBlack(panel) : false;
    header.classList.toggle('header--force-black', force);
  }

  function updateHomepageFromScroll() {
    const rect = header.getBoundingClientRect();
    const x = Math.round(rect.left + rect.width / 2);
    const y = Math.round(rect.top + rect.height / 2);
    const elements = document.elementsFromPoint(x, y);
    let force = false;
    for (const el of elements) {
      if (!el || !el.parentElement) continue;
      if (el.closest && el.closest('.header-section')) continue;
      if (checkForceBlack(el)) { force = true; break; }
      const key = getSectionKeyFromEl(el);
      if (key) break;
    }
    header.classList.toggle('header--force-black', force);
  }

  // ── Azur-ligne: black only on artdelatable slide ──
  function updateAzurLigne() {
    const active = document.querySelector('.azurligne-slide.is-active');
    const force = !!(active && active.querySelector('a[href*="azur_artdelatable"]'));
    header.classList.toggle('header--force-black', force);
  }

  const isIndex = document.body.classList.contains('template-index');
  const slider  = document.querySelector('.azurligne-slider');

  if (isIndex) {
    window.addEventListener('azur:panelchange', function (e) {
      var d = e.detail;
      if (!d || d.phase === 'end') return;
      updateHomepageFromPanel(d.panel);
    });
    // Fallback for mobile (no panel engine) or initial state before first event
    window.addEventListener('scroll', updateHomepageFromScroll, { passive: true });
    updateHomepageFromScroll();
  } else if (slider) {
    window.addEventListener('azur:lignechange', function (e) {
      const force = e.detail.index === 0;
      header.classList.toggle('header--force-black', force);
    });
    updateAzurLigne();
  }
})();
